module.exports = __webpack_public_path__ + "0f5485cd1c739ecbc4451698aa0927c6.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/01GoldenCityHafenbar.jpg
// module id = 751
// module chunks = 0